import React from 'react'
import image5 from "../img/Untitled_design_95_1024x1024.jpg"

const Slide5 = () => {
    return (
        <div className="">
            <div className="container">
                <div class="head"></div>
                <div className="image image5">
                    <img src={image5} alt=""></img>
                </div>
                <div className="text">
                    <span>
                        Als ältere Menschen wollen wir unseren Nachkommen eine Welt übergeben,
                        die lebenswert bleibt und die natürlichen Grundlagen unseres gemeinsamen Lebens bewahren hilft.
                        Daher sagen wir Alten zuversichtlich, optimistisch und mit klarer Überzeugung:
                        Bitte wählen Sie am 26.9. BÜNDNIS 90/DIE GRÜNEN.
                    </span>
                </div>
                <div className="text visdp">
                    (Alle mit dieser Aktion anfallenden Kosten werden privat getragen)
                </div>
                <div class="Footer"></div>
            </div>
        </div>
    )
}

export default Slide5;